<template>
  <header class="z-[110]">
    <div class="relative py-4 bg-white shadow">
      <div class="flex flex-row justify-between items-center px-4 md:px-8">
        <nuxt-link
          to="/"
          class="openly__logo"
        >
          <img
            src="/images/openly-logo-purple.svg"
            alt="Openly Logo"
            width="64"
            height="40"
          >
        </nuxt-link>
        <div class="flex flex-row items-center">
          <kudo-button
            color-variant="secondary"
            :is-disabled="$appLock.locked"
            data-cypress="header-new-quote"
            @click="newQuoteModal.open"
          >
            <i class="fas fa-plus" />
            New Client Quote
          </kudo-button>
          <div class="md:border-l border-white md:pl-8 hidden md:flex flex-row gap-x-8 items-center">
            <kudo-button
              shape-variant="round"
              color-variant="secondary"
              aria-label="Help Center"
              @click="openHelpCenter"
            >
              <i class="far fa-question" />
            </kudo-button>
            <kudo-button
              shape-variant="round"
              color-variant="secondary"
              aria-label="Live Chat"
              @click="$chat.openChat"
            >
              <i class="far fa-message" />
            </kudo-button>
          </div>
          <the-header-dropdown-menu class="ml-4 md:ml-8" />
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { KudoButton } from '@openly-engineering/kudo'

const newQuoteModal = inject('newQuoteModal')

function openHelpCenter() {
  window.analytics?.track('Help Center Header')
  window.open('https://help.openly.com/hc/en-us', '_blank')
}

</script>

<style scoped>
.router-link-active.openly__logo {
  @apply bg-transparent border-0;
}
</style>
